export const FETCH_DONATIONS_FOR_PAYROLL = 'app/PayrollApiPage/FETCH_DONATIONS_FOR_PAYROLL';
export const FETCH_DONATIONS_FOR_PAYROLL_SUCCESS =
  'app/PayrollApiPage/FETCH_DONATIONS_FOR_PAYROLL_SUCCESS';
export const FETCH_DONATIONS_FOR_PAYROLL_ERROR =
  'app/PayrollApiPage/FETCH_DONATIONS_FOR_PAYROLL_ERROR';
export const SELECT_DONATION_FOR_RESCHEDULE = 'app/PayrollApiPage/SELECT_DONATION_FOR_RESCHEDULE';

export interface FetchDonationsForPayrollAction {
  type: typeof FETCH_DONATIONS_FOR_PAYROLL;
  payrollRunId: string;
}

export enum DonationsFetchStatus {
  INITIAL,
  LOADING,
  LOADED,
  ERROR,
}

export const fetchDonationsForPayrollAction = (payrollRunId: string) =>
  ({
    type: FETCH_DONATIONS_FOR_PAYROLL,
    payrollRunId,
  } as const);
export const fetchDonationsForPayrollSuccessAction = (payrollRunId: string) =>
  ({
    type: FETCH_DONATIONS_FOR_PAYROLL_SUCCESS,
    payrollRunId,
  } as const);
export const fetchDonationsForPayrollErrorAction = (payrollRunId: string, error: Error) =>
  ({
    type: FETCH_DONATIONS_FOR_PAYROLL_ERROR,
    payrollRunId,
    error,
  } as const);

export const selectDonationForReschedule = (donationId: string | null) =>
  ({
    type: SELECT_DONATION_FOR_RESCHEDULE,
    donationId,
  } as const);
